import { Component, OnInit } from '@angular/core';
import { GetSystemUpdateCommandResponse, SystemUpdateDto, GetSystemUpdateCommandRequest, MarkSystemUpdateCommandRequest } from '../../data/CommandServiceDtos.generated';
import { ActivatedRoute, Router } from '@angular/router';
import { ControllerForViewBase } from '../framework/controller-for-view-base';
import { PageContainerService } from '../../services';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
  standalone: false,
  selector: 'feature-release-detail',
  templateUrl: './feature-release-detail.component.html',
  styleUrls: ['./feature-release-detail.component.scss']
})
export class FeatureReleaseDetailComponent extends ControllerForViewBase implements OnInit {
  feature: SystemUpdateDto;
  safeContent: SafeHtml;
  attachments: { Name: string, Url: string }[] = [];

  constructor(
    public pcs: PageContainerService, private router: Router, private route: ActivatedRoute, private sanitizer: DomSanitizer
  ) { super(pcs);}

  ngOnInit() {
    const idFromRoute = Number(this.route.snapshot.paramMap.get('id'));
    if (!isNaN(idFromRoute)) {
      this.getFeatureById(idFromRoute);
    } else {
      this.router.navigate(['feature-releases']);
    }
  }

  async getFeatureById(id: number) {
    const request = new GetSystemUpdateCommandRequest(); 
    request.Id = id;
    const getCommandResponse: GetSystemUpdateCommandResponse = await this.pcs.apiService.GetSystemUpdate(request);
    this.feature = getCommandResponse.SystemUpdate;
    if(this.feature)
    {
      const request = new MarkSystemUpdateCommandRequest();
      request.SystemUpdateId = this.feature.Id;
      this.pcs.apiService.MarkSystemUpdate(request);
    }
    this.safeContent = this.sanitizer.bypassSecurityTrustHtml(this.feature.Content || '');
    this.attachments = this.parseAttachments(this.feature.Attachments);
  }

  goBack() {
    this.router.navigate(['feature-releases']);
  }

  private parseAttachments(raw: any): { Name: string, Url: string }[] {
    if (!raw) { return []; }
    if (Array.isArray(raw)) { return raw; }
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
}

